MoyaComponents.register('extras.admin.boxImage', [
	'https://cdn.jsdelivr.net/npm/ms-dropdown@4.0.3/dist/js/dd.min.js',
	'https://cdn.jsdelivr.net/npm/ms-dropdown@4.0.3/dist/css/dd.min.css',
], (el) => {
	const moyaFetch = MoyaContainer.get('core.fetch');
	const itemElement = el.querySelector('#itemId');
	const imageElement = el.querySelector('#imageId');
	const imageUrlElement = el.querySelector('#imageUrl');
	itemElement.addEventListener('change', () => {
		updateImages();
		updateImageUrl();
	});

	const updateImages = () => {
		if (!itemElement) {
			return;
		}
		const itemId = parseInt(itemElement.value);
		moyaFetch.fetchJson(`/_/${moya.division}/extras/box/itemImages/${itemId}`).then(response => {
			updateSelectOptions(response);
		});
	};

	const updateImageUrl = () => {
		if (!itemElement || !itemElement.value) {
			return;
		}
		imageUrlElement.href = imageUrlElement.dataset.baseHref + parseInt(itemElement.value);
		imageUrlElement.classList.remove('hidden');
	};

	const updateSelectOptions = (options) => {
		imageElement.innerHTML = '';

		for (const [id, data] of Object.entries(options)) {
			const option = document.createElement('option');
			option.value = id;
			option.innerText = data.title ?? data.filename;
			option.dataset.image = data.url;
			option.dataset.description = data.description ?? '';
			if (imageElement.dataset.value === id) {
				option.selected = true;
			}
			imageElement.appendChild(option);
		}

		imageElement.setAttribute('is', 'ms-dropdow');
		window.MsDropdown.make(imageElement);
	};

	updateImages();
	updateImageUrl();
});
